module.exports = __webpack_public_path__ + "img/MP4.3627dc68.png";